import React, { useEffect, useState, useRef } from 'react';
import { useAppContext } from '../contexts/AppContext';

import Link from '../components/Link';
import { videoJson } from '../data/Data';

const GetToKnow = () => {
  return (
    <div className="page-container w-full h-full bg-cover bg-center relative flex justify-center items-center">
      <Link to={'/video/get1'} style={{padding:"2vw"}}>
        <div className='relative flex justify-start flex-col' style={{width:'43vw'}}>
          <img src='./assets/grid_modern.png' className='w-full shadow-md shadow-gray-300' />
          <span className='font-sofia uppercase text-black text-left text-title'>Get To Know PSO</span>
          <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', bottom:"0.5vw", right:'1vw'}} alt='Commercial' />
        </div>
      </Link>
      <Link to={'/video/get2'} style={{padding:"2vw"}}>
        <div className='relative flex justify-start flex-col' style={{width:'43vw'}}>
          <img src='./assets/map.png' className='w-full shadow-md shadow-gray-300' />
          <span className='font-sofia uppercase text-black text-left text-title'>About PSO</span>
          <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', bottom:"0.5vw", right:'1vw'}} alt='Commercial' />
        </div>
      </Link>
      <Link to={'/home'}>
        <img src='./assets/exit.png' className='absolute bottom-10 right-10' style={{width:'5vw'}} alt='Back Button' />
      </Link>
    </div>
  )
}

export default GetToKnow